import React from 'react';

type Props = {
  width?: string,
  height?: string,
  stroke?: string,
  className: string,
  transform?: string,
};

const ContextMenu = ({
  width,
  height,
  stroke,
  className,
  transform,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25 26"
    version="1.1"
    className={className}
    transform={transform}
  >
    <g id="Base" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Program---Weeks" transform="translate(-1115.000000, -686.000000)">
        <g id="Shevron-Copy-3" transform="translate(1088.000000, 686.142857)">
          <g id="ic_shevron" transform="translate(27.000000, 0.000000)">
            <use id="Oval-1" stroke={stroke} mask="url(#mask-2)" strokeWidth="2" xlinkHref="#path-1" />
            <path d="M12,9.85714286 C12.5522847,9.85714286 13,9.40942761 13,8.85714286 C13,8.30485811 12.5522847,7.85714286 12,7.85714286 C11.4477153,7.85714286 11,8.30485811 11,8.85714286 C11,9.40942761 11.4477153,9.85714286 12,9.85714286 Z M12,13.8571429 C12.5522847,13.8571429 13,13.4094276 13,12.8571429 C13,12.3048581 12.5522847,11.8571429 12,11.8571429 C11.4477153,11.8571429 11,12.3048581 11,12.8571429 C11,13.4094276 11.4477153,13.8571429 12,13.8571429 Z M12,17.8571429 C12.5522847,17.8571429 13,17.4094276 13,16.8571429 C13,16.3048581 12.5522847,15.8571429 12,15.8571429 C11.4477153,15.8571429 11,16.3048581 11,16.8571429 C11,17.4094276 11.4477153,17.8571429 12,17.8571429 Z" id="Combined-Shape" fill={stroke} />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

ContextMenu.defaultProps = {
  stroke: '#fff',
  height: '26px',
  width: '25px',
  transform: 'scale(0.9)',
};

export default ContextMenu;
